import React from 'react';
import FinanceSectionInteractiveWorkspace from './FinanceSectionInteractiveWorkspace';

const FinancePayrollWorkspace = ({ isDarkMode = false }) => (
  <FinanceSectionInteractiveWorkspace isDarkMode={isDarkMode} sectionKey="payroll" />
);

export default FinancePayrollWorkspace;
